(function (a) {
    var b = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
    var c = function (c, d) {
        function f(a) {
            a.css("width", "100%")
        }

        function g(a) {
            a.css("height", "100%")
        }

        var e = {forceWidth: false, forceHeight: false, forceSmart: false, bgColor: "inherit"};
        var h = a(c);
        var i = a.extend(e, d);
        h.load(function () {
            var a = h.parent().width();
            var b = h.parent().height();
            var c = h.parent().css("position");
            if (i.bgColor == "inherit")var d = h.parent().css("backgroundColor"); else var d = i.bgColor;
            h.css("width", "auto");
            h.css("height", "auto");
            if (i.forceSmart) {
                var e = h.width() / h.height();
                var j = a / b;
                if (e < j) f(h); else g(h)
            } else {
                if (i.forceWidth) f(h);
                if (i.forceHeight) g(h)
            }
            var k = h.width();
            var l = h.height();
            h.css({
                position: "relative",
                left: -(k - a) / 2 + "px",
                top: -(l - b) / 2 + "px"
            }).parent().css({position: c, overflow: "hidden", backgroundColor: d})
        });
        if (c.complete || c.complete === undefined) {
            var j = c.src;
            c.src = b;
            c.src = j
        }
    };
    a.fn.imgCentering = function (b) {
        return this.each(function (d) {
            var e = a(this);
            if (e.data("imgCentering"))return;
            var f = new c(this, b);
            e.data("imgCentering", f)
        })
    }
})(jQuery)
if(jQuery) (function(){

    $.extend($.fn, {

        rightClick: function(handler) {
            $(this).each( function() {
                $(this).mousedown( function(e) {
                    var evt = e;
                    $(this).mouseup( function() {
                        $(this).unbind('mouseup');
                        if( evt.button == 2 ) {
                            handler.call( $(this), evt );
                            return false;
                        } else {
                            return true;
                        }
                    });
                });
                $(this)[0].oncontextmenu = function() {
                    return false;
                }
            });
            return $(this);
        },

        rightMouseDown: function(handler) {
            $(this).each( function() {
                $(this).mousedown( function(e) {
                    if( e.button == 2 ) {
                        handler.call( $(this), e );
                        return false;
                    } else {
                        return true;
                    }
                });
                $(this)[0].oncontextmenu = function() {
                    return false;
                }
            });
            return $(this);
        },

        rightMouseUp: function(handler) {
            $(this).each( function() {
                $(this).mouseup( function(e) {
                    if( e.button == 2 ) {
                        handler.call( $(this), e );
                        return false;
                    } else {
                        return true;
                    }
                });
                $(this)[0].oncontextmenu = function() {
                    return false;
                }
            });
            return $(this);
        },

        noContext: function() {
            $(this).each( function() {
                $(this)[0].oncontextmenu = function() {
                    return false;
                }
            });
            return $(this);
        }

    });

})(jQuery);
$(document).ready(function () {

    $(document).ready(function() {
        $('.product-single__lc').rightClick( function(e) {
            return false;
        });
    });
  
    $("#quick-view .add-to-cart").click(function(e) {
      e.preventDefault();
        var o = {};
        var a = $('form[action="/cart/add"]').serializeArray();
        $.each(a, function () {
            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        $.ajax({
            type: 'POST',
            dataType: 'json',
            data: {
                quantity: o.quantity,
                id: o.id
            },
            url: '/cart/add.js',
            success: function (data) {
                console.log("success");
            }
        });
    });

    (function () {

        var search = window.location.search.substr(1),
            keys = {};

        search.split('&').forEach(function(item) {
            item = item.split('=');
            keys[item[0]] = item[1];
        });

        if(keys.popupIframe){
            $('body').addClass(keys.popupIframe);
            $('.product-single__lc').append($('.product-single__slider'));
            //$('<a href="#" class="quick-view__view-details">View Details</a>').insertAfter('.product-single__btns');
        	
        }

    })();
  	
  	$('.quickview-button .product__quick-view').click(function() {
        var product_handle = $(this).attr('id');
      	var productImg = $("#ProductThumbs"),
            currentImage = $(".quick-view__img-rc #ProductPhoto");
        
      	var searchURL = '/products/'+ product_handle;
      
      	$("#popup-iframe").html('');
      	$("#popup-iframe").append('<iframe src="/products/'+product_handle+'?popupIframe=popupIframe" class="iframe-popup-delay" width="815" height="570"></iframe>');
        setTimeout(function () {
            $('body').addClass('show-opacity');
            $('#popup-iframe').append('<a href="/products/'+product_handle+'" class="quick-view__view-details">View Details</a>');
          
        }, 2500);
      	$(".prices-list__youSave").hide();
      	$(".prices-list__newPrice").hide();
      	$(".prices-list__oldPrice").hide();
      	var getProduct = $.getJSON(searchURL, function (data) {
            if (data.product.variants.length > 0) {
              $(".variable-id-js").val(data.product.variants[0].id);
            }
          	console.log(data);
        	$("#AddToCart").data('product-id', data.product.id);
          	productImg.find('li').remove(); currentImage.find('img').remove();
            for(var i = 0; i<data.product.images.length; i++ ) {
              productImg.append("<li class='one-quarter is-active'><a href='/products/"+product_handle+"' class='product-single__thumbnail'><img src='"+data.product.images[i].src+"' alt='"+data.product.title+"'></a></li>");
            }
            currentImage.append('<img src="'+data.product.image.src+'" alt="'+data.product.title+'" id="ProductPhotoImg">');
        	$(".product-single__options .product-single__title").text(data.product.title);
          	$(".quick-view__view-details").attr('href','/products/'+product_handle);
            if ( data.product.variants[0].compare_at_price ) {
              $(".prices-list__oldPrice").show();
              $(".prices-list__oldPrice .money").text('$'+data.product.variants[0].compare_at_price);
            }
            if ( data.product.variants[0].price ) {
              $(".prices-list__newPrice").show();
              $(".prices-list__newPrice .money").text('$'+data.product.variants[0].price);
            }
          	if (Number(data.product.variants[0].compare_at_price) > Number(data.product.variants[0].price)) {
              $(".prices-list__youSave").show();
              $(".prices-list__youSave .prices-list__rc").html('');
              var res = Number(data.product.variants[0].compare_at_price) - Number(data.product.variants[0].price);
              var procent = (Number(data.product.variants[0].price) / Number(data.product.variants[0].compare_at_price)) * 100;
              $(".prices-list__youSave .prices-list__rc").append('<span class="money">$'+res+'</span> ('+procent.toFixed(2)+'%)');
            }
          
          	var el_style = $(".product-options .product-single__list-style"),
                el_size = $(".product-options .product-single__list-size"),
                el_color = $(".product-options .product-single__list-color");
          
          	el_style.html(''); el_size.html(''); el_color.html('');
          	$(".product-options.product-single__style.product-single__row").hide();
          	$(".product-options.product-single__size.product-single__row").hide();
          	$(".product-options.product-single__color.product-single__row").hide();
          
            if ( data.product.options.length >= 1 ) {
              for(var v = 0; v<data.product.options.length; v++ ) {
                if ( data.product.options[v].name.toLowerCase() == "style" ) {
                  $(".product-options.product-single__style.product-single__row").show();
                  for(var x = 0; x<data.product.options[v].values.length; x++ ) {
                  	el_style.append('<li class="row"><input type="radio" id="style'+x+'" name="style" class="hidden"><label data-name="style" for="style'+x+'" data-option="'+data.product.options[v].values[x]+'"><span>'+data.product.options[v].values[x]+'</span></label></li>');
                  }
                }
                if ( data.product.options[v].name.toLowerCase() == "size" ) {
                  $(".product-options.product-single__size.product-single__row").show();
                  for(var x = 0; x<data.product.options[v].values.length; x++ ) {
                  	el_size.append('<li class="row"><input type="radio" id="size'+x+'" name="size" class="hidden"><label data-name="size" for="size'+x+'" data-option="'+data.product.options[v].values[x]+'"><span>'+data.product.options[v].values[x]+'</span></label></li>');
                  }
                }
                if ( data.product.options[v].name.toLowerCase() == "color" ) {
                  $(".product-options.product-single__color.product-single__row").show();
                  for(var x = 0; x<data.product.options[v].values.length; x++ ) {
                  	el_color.append('<li class="row"><input type="radio" id="color'+x+'" name="color" class="hidden"><label data-name="color" for="color'+x+'" data-option="'+data.product.options[v].values[x]+'"><span style="background:'+data.product.options[v].values[x]+'"></span></label></li>');
                  }
                }
              }
            }
          	$(".product-single__variants-render").html('');
          	if ( data.product.variants.length >= 1 ) {
              for(var vr = 0; vr<data.product.variants.length; vr++ ) {
                var tl = data.product.variants[vr].title.replace(/ /g, "");
                $(".product-single__variants-render").append('<option data-title='+tl+' data-sku="'+data.product.variants[vr].sku+'" value="'+data.product.variants[vr].id+'">'+data.product.variants[vr].title+' - $'+data.product.variants[vr].compare_at_price+' USD</option>');
              }
            }
        });
    });



    $(window).on('load', function () {
        $('.cart__bot').each(function (i, e) {
            var $e = $(e),
                eInsert = $e.closest('.cart__productWrapper').find('.cart__product-variant');
            $e.insertAfter(eInsert).addClass('show');
            if (eInsert.text().replace(/\s+/g, ' ').length < 2) eInsert.remove();
        });
    });

    onScroll();

    $(window).on('scroll', function () {
        onScroll();
    });

    function onScroll() {
        if ($(window).scrollTop() > 29) $('body').addClass('on-scroll');
        else $('body').removeClass('on-scroll');
    }

    $(".buy-now-ajax__checkout").on("click", function (e) {
        e.preventDefault();

        //$.post('/cart/add.js', $('form[action="/cart/add"]').serialize());
        var o = {};
        var a = $('form[action="/cart/add"]').serializeArray();
        $.each(a, function () {
            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        $.ajax({
            type: 'POST',
            dataType: 'json',
            data: {
                quantity: o.quantity,
                id: o.id
            },
            url: '/cart/add.js',
            success: function (data) {
                document.location.href = '/checkout';
            }
        });
    });

    $(".other-block-load-btn").on("click", function () {

        var searchURL = '/search?type=article&q=' + $(this).data("serch");
        var currentAjaxRequest = null, offset = 1;
        var l_count = $(this).data("count"), all_count = $(this).data("allcount");

        currentAjaxRequest = $.getJSON(searchURL + '&view=json', function (data) {

            if (data.results_count == 0) {
                $('.search__result-text.other-block').hide();
                $('.btn-gray.other-block.other-block-load-btn').hide();
            } else {
                // If we have results.
                $.each(data.results, function (index, item) {
                    if (offset > 4) {
                        $(".grid.search__grid.other-block").append('<div class="grid__item grid__item-product large--one-quarter medium--one-half"><a href=' + item.url + ' class="grid__image product__image" title="' + item.title + '"><img src="' + item.blog_image + '" class="image-center" ></a><a class="product__title" href="' + item.url + '" title="' + item.title + '">' + item.title + '</a></div>');
                    }
                    offset++;
                });
                resizeImage();
                $('.search__result-text.other-block').hide();
                $('.btn-gray.other-block.other-block-load-btn').hide();

            }
        });
    });

    $(".product-block-load-btn").on("click", function () {

        var searchURL = '/search?type=product&q=' + $(this).data("serch");
        var currentAjaxRequest = null, offset = 1;
        var l_count = $(this).data("count"), all_count = $(this).data("allcount");

        currentAjaxRequest = $.getJSON(searchURL + '&view=json', function (data) {

            if (data.results_count == 0) {
                $('.search__result-text.product-block').hide();
                $('.btn-gray.product-block.product-block-load-btn').hide();
            } else {
                // If we have results.
                $.each(data.results, function (index, item) {
                    if (offset > 4) {
                        if (item.compare_at_price > item.price) {
                            $(".grid.search__grid.product-block").append('<div class="grid__item grid__item-product large--one-quarter medium--one-half"><div class="badges"><span class="badge badge--sale"><span class="badge__text">Sale</span></span></div><a href=' + item.url + ' class="grid__image product__image" title="' + item.title + '"><img src="' + item.thumbnail + '" class="image-center" ></a><a class="product__title" href="' + item.url + '" title="' + item.title + '">' + item.title + '</a><p class="product__price  product__priceSale "><span class="product__price-new"><span class=money>' + item.price + '</span></span><s class="product__price-old"><span class=money>' + item.compare_at_price + '</span></s></p></div>');
                        } else {
                            $(".grid.search__grid.product-block").append('<div class="grid__item grid__item-product large--one-quarter medium--one-half"><a href=' + item.url + ' class="grid__image product__image" title="' + item.title + '"><img src="' + item.thumbnail + '" class="image-center" ></a><a class="product__title" href="' + item.url + '" title="' + item.title + '">' + item.title + '</a><p class="product__price  product__priceSale "><span class="product__price-new"><span class=money>' + item.price + '</span></span></p></div>');
                        }
                    }
                    offset++;
                });
                resizeImage();
                $('.search__result-text.product-block').hide();
                $('.btn-gray.product-block.product-block-load-btn').hide();
            }
        });

    });

    $("#SortBy__search").change(function () {
        if ($(this).val() == "products") {
            $(".product-block").show();
            $(".other-block").hide();
        } else if ($(this).val() == "other") {
            $(".other-block").show();
            $(".product-block").hide();
        } else {
            $(".other-block").show();
            $(".product-block").show();
        }
    });

    function formatPrice(price) {
        return price.reverse().replace(/((?:\d{2})\d)/g, '$1 ').reverse();
    }

    // Need to extend String prototype for convinience
    String.prototype.reverse = function () {
        return this.split('').reverse().join('');
    }

    $(".cart__product-quantity .js-qty__adjust").on("click", function (e) {
        e.preventDefault();

        var curTarget = $(e.currentTarget),
            inputVal = curTarget.parent().children(".js-qty__num"),
            dataId = inputVal.data('id');
        dataId = dataId.substring(0, dataId.indexOf(':'));

        //$.post('/cart/update.js', 'updates['+dataId+']='+inputVal.val(), function (response) {});
        $.ajax({
            type: 'POST',
            dataType: 'json',
            data: {
                quantity: inputVal.val(),
                id: dataId
            },
            url: '/cart/change.js',
            success: function (data) {
                var line_price = (data.total_price / 100).toFixed(2);
                var parts = line_price.split('.'),
                    dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + ','),
                    cents = parts[1] ? ('.' + parts[1]) : '';
                $('#cartTotalPrice').html('$' + dollars + cents);
            }
        });
        /*$.ajax({
         type: 'GET',
         url: '/cart.json',
         dataType: 'jsonp',
         success: function(data) {
         //$('#cartTotalPrice').html(Shopify.formatMoney(data.total_price, settings.moneyFormat));
         var line_price = data.total_price/100;
         $('#cartTotalPrice').html(line_price.toFixed(2));
         }
         }); */
    });


    $(".product__quick-view").fancybox({
        padding: 0,
        /*maxWidth: 855,
        maxHeight: 578,*/
        fitToView: false,
        width: 'auto',
        height: 'auto',
        autoSize: false,
        closeClick: false,
        borderRadius: 0
    });

    $(".popup").fancybox({
        padding: 0,
        maxWidth: 575,
        maxHeight: 9999,
        fitToView: false,
        width: '70%',
        height: 'auto',
        autoSize: false,
        closeClick: false,
        borderRadius: 0
    });

    if ($('*').is('.template-product')) {

        $('.product-single__slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            asNavFor: '.product-single__thumbnails',
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        dots: true
                    }
                }
            ]
        });

        $('.product-single__thumbnails').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.product-single__slider',
            dots: false,
            arrows: false,
            focusOnSelect: true,
            infinite: false
        });

        $(document).on("click", ".MobileBuyItNow", function (e) {
          e.preventDefault();
          $(this).addClass("false-move");
        }).on("swiperight", ".MobileBuyItNow", function (e) {
          e.preventDefault();

          var left = $('.MobileBuyItNow').width() - 44,
              arrowSlide = $('.arrow-slide');

          $(this).off("click");

          arrowSlide.css({
            'left': left
          });

          setTimeout(function () {
            $('.MobileBuyItNow').addClass('swipe-end');
            $('.slide-buy-now').text('Added');
          }, 300);

          setTimeout(function () {
            var o = {};
            var a = $('form[action="/cart/add"]').serializeArray();
            $.each(a, function () {
              if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                  o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
              } else {
                o[this.name] = this.value || '';
              }
            });
            $.ajax({
              type: 'POST',
              dataType: 'json',
              data: {
                quantity: o.quantity,
                id: o.id
              },
              url: '/cart/add.js',
              success: function (data) {
                document.location.href = '/checkout';
              }
            });
          }, 400);

        });

        $('#convert-cm').on('click', function (e) {
            e.preventDefault();

            $('#convert-cm').addClass('active').attr('disabled', true);
            $('#convert-inc').removeClass('active').attr('disabled', false);

            $('.convert').each(function (index, elem) {
                var $elem = $(elem);
                $elem.text($elem.attr('data-cm')).next().text('cm');
            });

        });

        $('#convert-inc').on('click', function (e) {
            e.preventDefault();

            $('#convert-cm').removeClass('active').attr('disabled', false);
            $('#convert-inc').addClass('active').attr('disabled', true);

            $('.convert').each(function (index, elem) {
                var $elem = $(elem), $elemText = $elem.text() / 2.54;
                $elem.attr('data-cm', $elem.text()).text(+$elemText.toFixed(1)).next().text('inc');
            });

        });

        

        if ($(window).width() > 749) {
            $('.mobile-carusel').slick({
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                dots: true,
                arrows: true
            });
        }

        $(function () {
            $(document).on('mousedown', '.product-single__photos', function (e) {
                $(this)[0].oncontextmenu = function () {
                    return false;
                }
            });
        });

    }
      

    if ($('*').is('.template-index')) {
        $('.home-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            centerMode: true,
            variableWidth: true,
            touchMove: false,
            swipe: false,
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        arrows: true,
                        dots: false,
                        touchMove: true,
                        swipe: true,
                        centerMode: false,
                        variableWidth: false
                    }
                }
            ]
        });
      
        $('.product-single-home__slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.product-single-home__thumbnails',
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              dots: true
            }
          }
        ]
      });

      $('.product-single-home__thumbnails').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.product-single-home__slider',
        dots: false,
        arrows: false,
        focusOnSelect: true,
        infinite: false
      });
      
      $(document).on("click", ".MobileBuyItNow", function (e) {
            e.preventDefault();
            $(this).addClass("false-move");
        }).on("swiperight", ".MobileBuyItNow", function (e) {
            e.preventDefault();

            var left = $('.MobileBuyItNow').width() - 44,
                arrowSlide = $('.arrow-slide');

            $(this).off("click");

            arrowSlide.css({
                'left': left
            });

            setTimeout(function () {
                $('.MobileBuyItNow').addClass('swipe-end');
                $('.slide-buy-now').text('Added');
            }, 300);

            setTimeout(function () {
                var o = {};
                var a = $('form[action="/cart/add"]').serializeArray();
                $.each(a, function () {
                    if (o[this.name] !== undefined) {
                        if (!o[this.name].push) {
                            o[this.name] = [o[this.name]];
                        }
                        o[this.name].push(this.value || '');
                    } else {
                        o[this.name] = this.value || '';
                    }
                });
                $.ajax({
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        quantity: o.quantity,
                        id: o.id
                    },
                    url: '/cart/add.js',
                    success: function (data) {
                        document.location.href = '/checkout';
                    }
                });
            }, 400);

        });

    }

    resizeMobile();
    resizeImage();

    setTimeout(function () {
        resizeBanner();
    }, 500);

    $(window).resize(function () {
        resizeBanner();
        resizeImage();
        resizeMobile();
    });
  
         
  
    $('.search-link').on('click', function (e) {
        e.preventDefault();
        $('.search-popup').slideToggle();
        $('html,body').animate({scrollTop: 0}, '300');
    });

    $('#search-popup__close').on('click', function (e) {
        e.preventDefault();
        $('.search-popup').slideUp();
    });

    $('[class^=product-single__list-] input:not(:disabled) + label').unbind().on('click', function () {

        var $this = $(this),
            option = $this.data('option');

        $this.closest('.product-single__row').find('.selected-option').css({'display': 'block'}).find('span').html(option);

    });

    if ($(window).width() < 768) {
/*
        $('.product-single__slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            adaptiveHeight: true
        });*/

        $('.drop-nav, .footer__nav-mobile, .footer__drop--link').on('click', function (e) {
            e.preventDefault();

            var dropContent = $(this).next('*');

            $(this).toggleClass('opened').parent().toggleClass('opened');

            if (dropContent.is(':visible')) {
                dropContent.stop().slideUp();
            } else {
                dropContent.stop().slideDown();
            }

        });

        $('.single-page__content ul li').on('click', function () {
            $(this).toggleClass('opened').find('div.dropdown').slideToggle();
        });


        if ($('*').is('.mobile-carusel--true')) {
            $('.mobile-carusel--true').slick({
                infinite: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: true,
                arrows: true,
                centerMode: false
            });
        }

    } else {
        $('.footer__subscribe').removeClass('grid__item').insertAfter('.footer__about-us');
    }


});

function resizeBanner() {
    var banner = $('.shop-collection__img');

    if ($(window).width() < 480) {
        banner.css({
            'margin-left': -(banner.width() - $(window).width()) / 2
        });
    }
}

function resizeImage() {

    //if ($(window).width() > 480) {
        $('.image-center').imgCentering({
            forceSmart: true
        });
        setTimeout(function () {
            $('.image-center').css({'opacity': '1'});
        }, 150)
   // }

}

function resizeMobile() {

    if ($(window).width() > 992) {
        $('.footer__nav-col-third').insertAfter('.footer__nav-col-second');
        $('.footer__copyright__payments').insertAfter('.footer__copyright-nav');
    }

    $('#go-top').on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 1000);
    });

    $('.cart-select').select();

    $(".js-qty button").click(function () {
        $(".js-qty").addClass("js-qty_active");

    });
}

$(document).ready(function() {
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });